/**
 * Retell's v3 gateway transport doesn't deliver agent_start/stop_talking, so the
 * speaking indicator is derived from the agent's audio level: RMS of each
 * analyser snapshot against a threshold, with a hold so pauses between words
 * don't flicker. push() returns 'start' | 'stop' | null (edges only).
 */
export const createAgentTalkDetector = ({ threshold = 0.015, holdMs = 350, now = () => Date.now() } = {}) => {
  let talking = false;
  let lastLoudAt = 0;
  return {
    push(samples) {
      let sum = 0;
      for (let i = 0; i < samples.length; i++) sum += samples[i] * samples[i];
      const rms = samples.length ? Math.sqrt(sum / samples.length) : 0;
      const t = now();
      if (rms >= threshold) {
        lastLoudAt = t;
        if (!talking) { talking = true; return 'start'; }
        return null;
      }
      if (talking && t - lastLoudAt >= holdMs) { talking = false; return 'stop'; }
      return null;
    },
    reset() { talking = false; lastLoudAt = 0; },
  };
};
